import React from 'react';
import ChartsContainer from '../../Componant/Charts/ChartsJs';

const Charts = () => {
  return (
    <div className='page-body'>
      <ChartsContainer />
    </div>
  );
};

export default Charts;
